import { useTestLinks as useTestLinksMutation } from '@data';
import { useShareMailboxContext, useToastsContext } from '@utils';
import { getUserEmail, handleError, isRequestTimeout } from '@utils-global';

export const useTestLinks = () => {
  const { showToast } = useToastsContext();
  const { isSharedMailbox, originalUserEmail } = useShareMailboxContext();

  const { mutate: testLinks, isPending: isTestLinksPending } = useTestLinksMutation();

  const handleTestLinks = () => {
    // if it's shared mailbox we can't use getUserEmail since it'll return shared mailbox address
    const userEmail = isSharedMailbox ? originalUserEmail : getUserEmail();

    testLinks(
      {
        email: userEmail,
      },
      {
        onSuccess: ({ data: response }) => {
          if (response.url) {
            window.open(response.url, '_blank');
          }
        },
        onError: (error) => {
          handleError(error, () => {
            showToast(
              isRequestTimeout(error) ? 'errors.testLinks.timeout' : 'errors.testLinks.error',
            );
          });
        },
      },
    );
  };

  return { isTestLinksPending, handleTestLinks };
};
